import Identity from "./Identity.model";
//import DateToString from '../helpers/dateToString';
export default class Patient {
    constructor() {
        this.id;
        this.incidentId;
        this.identityId;
        this.passengerPosition;
        this.patientType;
        this.seatbeltOn = true;
        this.consentFormFileId;
        this.ambulanceReportFileId;
        this.transferLetterFileId;
        this.isDeleted;
        this.createdByIdentityId;
        this.createdAt;
        this.modifiedAt;
        this.consentFormAvailable;
        this.ambulanceReportAvailable;
        this.transferLetterAvailable;
        this.affidavitFileId;
        this.patientIncidentReportFileId;
        this.admissionDate;
        this.overrideSuspension;
        this.isAdmitted;
        this.admittedToServiceProviderId;
        this.admittedToServiceProviderDate;
        this.admittedSmsSent;
        this.legalConsentFileId;
        this.legalConsentAvailable;
        this.attorneyMandateFileId;
        this.attorneyMandateAvailable;
        this.missingLegalDocuments;
        this.suspendedMissingLegalDocuments;
        this.suspendedMissingDocuments;
        this.missingDocuments;
        this.mediKreditAddCardId;
        this.isVerified;
        this.isDischarged;
        this.isFinalised;
        this.isFraudulent;
        this.isSuspended;
        this.isAdminAccount;
        this.isTransfer;
        this.transferFromFacility;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.incidentId = setEntity.incidentId;
        this.identityId = setEntity.identityId;
        this.passengerPosition = setEntity.passengerPosition;
        this.patientType = setEntity.patientType;
        this.seatbeltOn = setEntity.seatbeltOn;
        this.consentFormFileId = setEntity.consentFormFileId;
        this.ambulanceReportFileId = setEntity.ambulanceReportFileId;
        this.transferLetterFileId = setEntity.transferLetterFileId;
        this.isDeleted = setEntity.isDeleted;
        this.createdByIdentityId = setEntity.createdByIdentityId;
        this.createdAt = setEntity.createdAt;
        this.modifiedAt = setEntity.modifiedAt;
        this.consentFormAvailable = setEntity.consentFormAvailable;
        this.ambulanceReportAvailable = setEntity.ambulanceReportAvailable;
        this.transferLetterAvailable = setEntity.transferLetterAvailable;
        this.affidavitFileId = setEntity.affidavitFileId;
        this.patientIncidentReportFileId = setEntity.patientIncidentReportFileId;
        this.admissionDate = setEntity.admissionDate ? new Date(setEntity.admissionDate) : null;
        this.overrideSuspension = setEntity.overrideSuspension;
        this.isAdmitted = setEntity.isAdmitted;
        this.admittedToServiceProviderId = setEntity.admittedToServiceProviderId;
        this.admittedToServiceProviderDate = setEntity.admittedToServiceProviderDate;
        this.admittedSmsSent = setEntity.admittedSmsSent;
        this.legalConsentFileId = setEntity.legalConsentFileId;
        this.legalConsentAvailable = setEntity.legalConsentAvailable;
        this.attorneyMandateFileId = setEntity.attorneyMandateFileId;
        this.attorneyMandateAvailable = setEntity.attorneyMandateAvailable;
        this.missingLegalDocuments = setEntity.missingLegalDocuments;
        this.suspendedMissingLegalDocuments = setEntity.suspendedMissingLegalDocuments;
        this.suspendedMissingDocuments = setEntity.suspendedMissingDocuments;
        this.missingDocuments = setEntity.missingDocuments;
        this.mediKreditAddCardId = setEntity.mediKreditAddCardId;
        this.isVerified = setEntity.isVerified;
        this.isDischarged = setEntity.isDischarged;
        this.isFinalised = setEntity.isFinalised;
        this.isFraudulent = setEntity.isFraudulent;
        this.isSuspended = setEntity.isSuspended;
        this.isAdminAccount = setEntity.isAdminAccount;
        this.isTransfer = setEntity.isTransfer;
        this.transferFromFacility = setEntity.transferFromFacility;

        this.identity = setEntity.identity ? new Identity().set(setEntity.identity) : new Identity();

        return this;
    }
}
